/**
 * @date: 12/15/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */

import React, {useEffect, useState} from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {getDateFromString, printDateHtml} from "../utils/cert-helper";
import {Backdrop, CircularProgress, Divider, Icon, IconButton, Pagination, styled, Tooltip} from '@mui/material';
import {TableContainer} from "@mui/material";
import ManageUserMenu from "./ManageUserMenu";
import KeyValuePair from "../utils/components/KeyValuePair";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import {Link, Route, Routes} from "react-router-dom";
import OrganizationUserEditDialog from "./OrganizationUserEditDialog";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import {handleHttpResponse} from "../utils/http-helpers";
import {ApiUrl} from "../utils/portal-urls";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import OrganizationUserTokenLinkDialog from "./OrganizationUserTokenLinkDialog";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OrganizationUserDeleteDialog from "./OrganizationUserDeleteDialog";

const StyledBackdrop = styled(Backdrop)(({theme}) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
}))

export default function ShowUsersAsList (props){
    const users = props.users || [];
    const myself = props.myself || {};
    const myselfId =  myself && myself.id || 0;
    console.log('showingUsersAsList, login As user ', myselfId, users);
    const handleEditUser = props.handleEditUser || null;
    const size = props.size || 'large'; // small | large
    const setRefresh = props.setRefresh;

    const [tokenLink, setTokenLink] = useState();
    const [loading, setLoading] = useState(false);
    const [slideDialogOpen, setSlideDialogOpen] = useState(false);
    const [userId, setUserId] = useState();

    const [userDeleteDialogOpen, setUserDeleteDialogOpen] = useState(false);
    const [userEditDialogOpen, setUserEditDialogOpen] = useState(false);
    const [user, setUser] = useState({});

    const currentUser = (userId) => {
        return myself.id === userId;
    }

    // const handleIconButtonClick = (id) => {
    //     getUserActivationLink(id);
    //     setSlideDialogOpen(true);
    // }

    const getUserActivationLink = (id) => {
        setLoading(true);
        let url = ApiUrl.Activation.Token.GetTokenLink.getPath(id);

        console.log("ShowUsersAsList:")
        console.log("URL " + url);
        fetch(url)
            .then(handleHttpResponse)
            .catch((err) => {
                setLoading(false);
                console.error("Failed to get token link: ", err);
            })
            .then((res) => {
                if (res) {
                    setTokenLink(res.linkUri);
                    setSlideDialogOpen(true);
                    setLoading(false);
                }
            })
    }

    const handleDeleteClick = (user) => {
        setUserDeleteDialogOpen(true);
        setUser(user);
    }

    const handleEditClick = (user) => {
        setUserEditDialogOpen(true);
        setUser(user);
    }

    return (<div>
        {tokenLink && slideDialogOpen && <OrganizationUserTokenLinkDialog open={slideDialogOpen} close={(c) => setSlideDialogOpen(c)} userId={userId} tokenLink={tokenLink}/>}
        <TableContainer sx={{mt: '10px'}}>
            {/*{user &&*/}
            {/*    <OrganizationUserEditDialog user={user} setUserEditDialogOpen={(c) => setUserEditDialogOpen(c)} userEditDialogOpen={userEditDialogOpen} />*/}
            {/*}*/}
            {user &&
                <OrganizationUserDeleteDialog setRefresh={(c) => setRefresh(c)} user={user} setUserDeleteDialogOpen={(c) => setUserDeleteDialogOpen(c)} userDeleteDialogOpen={userDeleteDialogOpen} />
            }

            <Table sx={{ m: 0}}>
                <TableHead>
                    {size === 'large' &&
                        <TableRow>
                            {/*<TableCell>First Name</TableCell>*/}
                            {/*<TableCell>Last Name</TableCell>*/}
                            <TableCell>Name</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Alert Level</TableCell>
                            <TableCell sx={{}}>Email</TableCell>
                            {/*<TableCell>Phone</TableCell>*/}
                            <TableCell>Status</TableCell>
                            {/*<TableCell>Created Date</TableCell>*/}
                            <TableCell>Last Login</TableCell>
                            {/*<TableCell>&nbsp;&nbsp;Edit / Delete</TableCell>*/}
                            <TableCell>Action</TableCell>
                            {/*<TableCell>Actions</TableCell>*/}
                        </TableRow>
                    }
                    {size !== 'large' &&
                        <TableRow>
                            <TableCell>Name / Role</TableCell>
                            <TableCell>Contact Info</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Created Date</TableCell>
                            <TableCell>Last Login</TableCell>
                            {/*<TableCell>&nbsp;&nbsp;Edit / Delete</TableCell>*/}
                            <TableCell>Action</TableCell>
                            {/*{ handleEditUser && <TableCell>Actions</TableCell>}*/}
                        </TableRow>
                    }
                </TableHead>
                <TableBody>
                    {users && users.length > 0 && users.map((u) => {

                        if (size === 'large') {
                            return (
                                <TableRow key={u.id} selected={currentUser(u.id)}>
                                    {/*<TableCell> {u.givenName} </TableCell>*/}
                                    <TableCell> {u.givenName} {u.familyName} </TableCell>
                                    <TableCell>{u.userType}</TableCell>
                                    <TableCell>{u.alertLevel}</TableCell>
                                    <TableCell>{u.email}</TableCell>
                                    {/*<TableCell>{u.phone}</TableCell>*/}
                                    {u.status === 'active' ?
                                        <TableCell>{u.status}</TableCell> :
                                        <TableCell>{u.status}
                                            <Tooltip title={"Copy the activation link"} arrow>
                                                <IconButton onClick={() => getUserActivationLink(u.id)}>
                                                    <ContentCopyIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    }
                                    {/*<TableCell>{u.createdTs && printDateHtml( getDateFromString(u.createdTs) )}</TableCell>*/}
                                    <TableCell>{u.updatedTs && printDateHtml( getDateFromString(u.updatedTs) )}</TableCell>
                                    <TableCell>
                                        {/*<Tooltip title="Edit user" arrow>*/}
                                        {/*        <IconButton>*/}
                                        {/*        <EditIcon color="primary" />*/}
                                        {/*    </IconButton>*/}
                                        {/*</Tooltip>*/}
                                        <Tooltip title="Delete user" arrow>
                                            <span>
                                                <IconButton onClick={() => handleDeleteClick(u)} disabled={currentUser(u.id)}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                    {/*{handleEditUser && <TableCell>*/}
                                    {/*    {u.id !== myselfId && <ManageUserMenu id={u.id} status={u.status} handleEditUser={handleEditUser} /> }*/}
                                    {/*</TableCell> }*/}


                                </TableRow>
                            );
                        } else {
                            return (
                                <TableRow key={u.id} selected={currentUser(u.id)}>
                                    <TableCell>
                                        <div><KeyValuePair name='Name' value={`${u.givenName}, ${u.familyName}`} /></div>
                                        <div><KeyValuePair name='Role' value={`${u.userType}`} /></div>
                                    </TableCell>
                                    <TableCell>
                                        <div><KeyValuePair name='Email' value={`${u.email}`} /></div>
                                        <div><KeyValuePair name='Phone' value={`${u.phone}`} /></div>
                                    </TableCell>
                                    {u.status === 'active' ?
                                        <TableCell>{u.status}</TableCell> :
                                        <TableCell>{u.status}
                                            <IconButton onClick={() => getUserActivationLink(u.id)}>
                                                <ContentCopyIcon />
                                            </IconButton>
                                        </TableCell>
                                    }
                                    <TableCell >{u.createdTs && printDateHtml( getDateFromString(u.createdTs) )}</TableCell>
                                    <TableCell >{u.updatedTs && printDateHtml( getDateFromString(u.updatedTs) )}</TableCell>
                                    {/*{handleEditUser && <TableCell>*/}
                                    {/*    {u.id !== myselfId && <ManageUserMenu id={u.id} status={u.status} handleEditUser={handleEditUser} /> }*/}
                                    {/*</TableCell> }*/}
                                    <TableCell>
                                        {/*<Tooltip title="Edit user" arrow>*/}
                                        {/*    <IconButton >*/}
                                        {/*        <EditIcon color="primary" />*/}
                                        {/*    </IconButton>*/}
                                        {/*</Tooltip>*/}
                                        <Tooltip title="Delete user" arrow>
                                            <span>
                                                <IconButton onClick={() => handleDeleteClick(u)} disabled={currentUser(u.id)}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        }
                    })}
                </TableBody>
            </Table>
        </TableContainer>
        <StyledBackdrop open={loading}>
            <CircularProgress color="inherit"/> Loading ...
        </StyledBackdrop>
    </div>);
}
